export const withComma = (x) =>
  x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
export const fixed2 = (num) => (Math.round(num * 100) / 100).toFixed(2)
